<div>
  <!-- Email verification banner (shown only to unverified email users) -->
  <app-email-verification-banner />

  @if (currentRoute() !== 'sign-in' && currentRoute() !== 'sign-up') {
    <app-navbar (navigate)="onNavigate($event)"></app-navbar>
  }
  <main>
    <router-outlet></router-outlet>
  </main>
  @if (currentRoute() !== 'sign-in' && currentRoute() !== 'sign-up') {
    <app-footer (navigate)="onNavigate($event)"></app-footer>
    <app-mobile-nav [currentPage]="currentRoute()" (navigate)="onNavigate($event)"></app-mobile-nav>
  }
</div>

<!-- Global Toast Container -->
<app-toast-container />

<!-- Cookie Consent Banner (GDPR) -->
<app-cookie-consent />

<!-- Floating Contact Us Button -->
<app-contact-us-button (contactClick)="onContactUs()" />
